import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, HelpBlock } from 'react-bootstrap';
import InputRange from 'react-input-range';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SliderField extends Component {

	constructor(props) {
		super(props);

		this.state = {
			originalValue: props.input.value
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.input.value && !nextProps.meta.dirty) {
			this.setState({ originalValue: nextProps.input.value });
		}
	}

	handleReset(e) {
		e.stopPropagation();
		const { input } = this.props;
		input.onChange(this.state.originalValue);
	}

	render() {
		const {
			input,
			meta: { error, touched },
			label,
			minValue,
			id,
			step,
			layout,
			maxValue,
			unit,
		} = this.props;

		const showError = error && touched;
		const inputBlock = () => {
			return (
				<div style={{ margin: '20px 15px 0' }}>
					<div className='row'>
						<div className='col-xs-9'>
							<InputRange
								maxValue={maxValue || 20}
								minValue={minValue || 0}
								value={input.value === '' ? minValue : parseInt(input.value, 10)}
								onChange={input.onChange}
								formatLabel={value => `${value} ${unit}`}
								step={step || 1}
							/>
						</div>
						<div className='col-xs-3'>
							<input
								type="number"
								value={input.value || minValue}
								autoComplete="off"
								className="form-control"
								onChange={input.onChange}
								style={{ position: 'relative', bottom: 10 }}
								disabled
							/>
						</div>
					</div>
					<HelpBlock>{showError ? error : ''}</HelpBlock>
				</div>
			);
		};

		if (layout === 'horizontal') {
			return (
				<FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
					<Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
						{label} &nbsp;&nbsp;
						<span style={{ cursor: 'pointer' }} onClick={this.handleReset.bind(this)} >
							<FontAwesomeIcon icon='sync' />
						</span>
					</Col>
					<Col xs={9}>
						{inputBlock()}
					</Col>
				</FormGroup>
			);
		}

		return (
			<FormGroup
				controlId={id || input.name}
				className={label ? 'label-present' : 'label-blank'}
				validationState={showError ? 'error' : null}
			>
				{label ?
					<ControlLabel>
						{label} &nbsp;&nbsp;
						<span style={{ cursor: 'pointer' }} onClick={this.handleReset.bind(this)} >
							<FontAwesomeIcon icon='sync' />
						</span>
					</ControlLabel> : ''}
				{inputBlock()}
			</FormGroup>
		);
	}
}
